import Vue from 'vue'
import Vuex from 'vuex'
import { getRegion } from './region'

Vue.use(Vuex)

function getSaveCookie(cName) {
  cName = cName + '='
  const cookieData = document.cookie
  let start = cookieData.indexOf(cName)
  let cValue = ''
  if (start !== -1) {
    start += cName.length
    let end = cookieData.indexOf(';', start)
    if (end === -1) end = cookieData.length
    cValue = cookieData.substring(start, end)
  }
  return unescape(cValue)
}

function getLanguage() {
  const savedLang = getSaveCookie('lang');

  if (savedLang) {
    if (savedLang === 'ko') {
      return 'ko'
    }
    else {
      return 'en'
    }
  } else {
    if (typeof navigator === 'undefined') return 'en'
    const locale = (
      navigator.language ||
      navigator.userLanguage ||
      ''
    ).toLowerCase()

    if (locale.startsWith('ko')) {
      return 'ko'
    }
    else {
      return 'en'
    }

    // else if (locale.startsWith('zh')) {
    //   return 'zh'
    // } else if (locale.startsWith('ja')) {
    //   return 'ja'
    // }
  }
}

export default new Vuex.Store({
  state: {
    token: '',
    isLogin: '',
    firstAccess: getSaveCookie('first'),
    whaleloginmodal: false,
    lang: getLanguage(),
    region: getRegion(),
    guidemodal: true,
    regionCheck: {
      status: false,
      type: '',
      text: '',
      location: ''
    },
    regionChange: {
      status: false,
    }
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {}
})
